// extracted by mini-css-extract-plugin
export default {"videoPlayerContainer":"VideoPlayer_videoPlayerContainer__G6pVa","videoWrapper":"VideoPlayer_videoWrapper__RDDnq","videoSpacing":"VideoPlayer_videoSpacing__+edQJ"};